import Vue from 'vue';
import JsUtil from '../util/JsUtil';

const DgdMockDataLoader = {
  /**
   * Returns a mock list of all location types (Ortstypen) as JSON array.
   *
   * @returns The JSON array with all location types (key: 'v_ortstyp')
   */
  async getLocationTypeList () {
    const randomTimeout = JsUtil.randomIntFromInterval(100, 500);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve([
          {
            'v_ortstyp': 'Aufnahmeort'
          },
          {
            'v_ortstyp': 'Geburtsort'
          },
          {
            'v_ortstyp': 'Mundartort'
          },
          {
            'v_ortstyp': 'Wohnort'
          }
        ])
      }, randomTimeout);
    })
  },

  /**
   * Returns a mock list of all corpora (Korpora) as JSON array.
   *
   * @returns The GeoJSON for the given filter parameters
   */
  async getCorpusList () {
    return new Promise((resolve, reject) => {
      resolve([
        {
          v_corpus_id: 'FOLK',
          v_corpus_name: 'Forschungs- und Lehrkorpus Gesprochenes Deutsch',
          v_corpus_cat: 'Gesprächskorpora'
        },
        {
          v_corpus_id: 'ZW',
          v_corpus_name: 'Deutsche Mundarten: Zwirner-Korpus',
          v_corpus_cat: 'Gesprächskorpora'
        },
        {
          v_corpus_id: 'SW--',
          v_corpus_name: 'Deutsche Mundarten: Schwarzwald',
          v_corpus_cat: 'Gesprächskorpora'
        },
        {
          v_corpus_id: 'AD',
          v_corpus_name: 'Australiendeutsch',
          v_corpus_cat: 'Kategorie 2'
        },
        {
          v_corpus_id: 'WISC',
          v_corpus_name: 'Deutsch in Wisconsin',
          v_corpus_cat: 'Kategorie 3'
        },
        {
          v_corpus_id: 'DNAM',
          v_corpus_name: 'Deutsch in Namibia',
          v_corpus_cat: 'Kategorie 2'
        },
        {
          v_corpus_id: '3MBG',
          v_corpus_name: 'Noch ein 3er Korpus',
          v_corpus_cat: 'Kategorie 3'
        }
      ])
    })
  },

  /**
   * Returns a mock list of all countries as JSON array.
   *
   * @returns The country JSON array
   */
  async getCountryList () {
    const randomTimeout = JsUtil.randomIntFromInterval(100, 500);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const countries = [
          {
            'ISO-Code': 'DE',
            Langname: 'Deutschland'
          },
          {
            'ISO-Code': 'AU',
            Langname: 'Australien'
          },
          {
            'ISO-Code': 'BE',
            Langname: 'Belgien'
          },
          {
            'ISO-Code': 'BO',
            Langname: 'Bolivien'
          },
          {
            'ISO-Code': 'Brasilien',
            Langname: 'BR'
          }
        ];

        const modCountries = [];
        countries.forEach(r => {
          modCountries.push({
            name: r.Langname,
            iso: r['ISO-Code'],
            clientId: r['ISO-Code']
          })
        });

        modCountries.unshift({
          name: '- Keine Auswahl -',
          clientId: null
        });

        resolve(modCountries);
      }, randomTimeout);
    })
  },

  /**
   * Returns a mock list of all regions for the given country as JSON array.
   *
   * @returns The region JSON array
   */
  async getRegionList (countryCode) {
    const randomTimeout = JsUtil.randomIntFromInterval(100, 500);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const regions = [
          {
            Region: countryCode + ' ' + 'Baden-Württemberg'
          },
          {
            Region: countryCode + ' ' + 'Bayern'
          },
          {
            Region: countryCode + ' ' + 'Berlin'
          },
          {
            Region: countryCode + ' ' + 'Brandenburg'
          },
          {
            Region: countryCode + ' ' + 'Bremen'
          }
        ];

        const modRegions = [];
        regions.forEach(r => {
          modRegions.push({
            name: r.Region,
            clientId: r.Region
          })
        });

        modRegions.unshift({
          name: '- Keine Auswahl -',
          clientId: null
        });

        resolve(modRegions);
      }, randomTimeout);
    });
  },

  /**
   * Returns a mock list of all districts for the given country and region as
   * JSON array.
   *
   * @returns The region JSON array
   */
  async getDistrictList (countryCode, regionName) {
    const randomTimeout = JsUtil.randomIntFromInterval(100, 500);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const districts = [
          {
            Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 1'
          },
          {
            Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 2'
          },
          {
            Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 3'
          },
          {
            Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis 4'
          },
          {
            Landkreis: countryCode + '-' + regionName + ' ' + 'Kreis n'
          }
        ];

        const modDistricts = [];
        districts.forEach(d => {
          modDistricts.push({
            name: d.Landkreis,
            clientId: d.Landkreis
          })
        });

        modDistricts.unshift({
          name: '- Keine Auswahl -',
          clientId: null
        });

        resolve(modDistricts);
      }, randomTimeout);
    });
  },

  /**
   * Returns a mock list of locations (Ortsdaten) as GeoJSON FeatureCollection.
   *
   * @returns The GeoJSON for the given filter parameters
   */
  async getLocationList () {
    let mockUrl = './static/data/zw-ereignis-aufnahmeort.geo.json';

    if (Vue.prototype.$mockGeoData === 1) {
      mockUrl = './static/data/isz-vater-sprecher-geburtsort.geo.json';

      Vue.prototype.$mockGeoData = 2;
    } else if (Vue.prototype.$mockGeoData === 2) {
      mockUrl = './static/data/isw-sprecher-geburtsort.geo.json';
      Vue.prototype.$mockGeoData = 1;
    }

    if (!Vue.prototype.$mockGeoData) {
      Vue.prototype.$mockGeoData = 1;
    }

    const resp = await fetch(mockUrl, {});
    return resp.json();
  },

  /**
   * Returns a mock list of locations (Ortsdaten) as GeoJSON FeatureCollection,
   * based on a geographic filter.
   *
   * @returns
   */
  async getLocationListGeo () {
    const randomTimeout = JsUtil.randomIntFromInterval(100, 500);
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        const geojson = {
          'type': 'FeatureCollection',
          'features': [
            {
              'type': 'Feature',
              'properties': {
                'Dummy Dataset': true,
                'lorem': 'ipsum',
                'v_corpus_id': 'FOLK',
                'v_corpus_name': 'Forschungs- und Lehrkorpus Gesprochenes Deutsch'
              },
              'geometry': {
                'type': 'Point',
                'coordinates': [
                  9.29443359375,
                  49.51807644873301
                ]
              }
            },
            {
              'type': 'Feature',
              'properties': {
                'Dummy Dataset': true,
                'foo': 'bar',
                'v_corpus_id': 'FOLK',
                'v_corpus_name': 'Forschungs- und Lehrkorpus Gesprochenes Deutsch'
              },
              'geometry': {
                'coordinates': [
                  9.59106445312733,
                  49.35375571831017
                ],
                'type': 'Point'
              }
            }
          ]
        };

        resolve(geojson);
      }, randomTimeout);
    })
  }

};

export default DgdMockDataLoader;



// WEBPACK FOOTER //
// ./app/ids/DgdMockDataLoader.js